import { render, staticRenderFns } from "./CustomersFilter.vue?vue&type=template&id=56d3cce5&scoped=true&"
import script from "./CustomersFilter.vue?vue&type=script&lang=js&"
export * from "./CustomersFilter.vue?vue&type=script&lang=js&"
import style0 from "./CustomersFilter.vue?vue&type=style&index=0&id=56d3cce5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d3cce5",
  null
  
)

export default component.exports